import { render, staticRenderFns } from "./SplitPanelB.vue?vue&type=template&id=233ad4e8&scoped=true"
import script from "./SplitPanelB.vue?vue&type=script&lang=js"
export * from "./SplitPanelB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233ad4e8",
  null
  
)

export default component.exports